import { vsName as ConfigurationsComponentName } from "./component";

import {
  vsProviderName as machineDetailTabsProviderName,
  MachineDetailTabsProvider,
} from "../../../../components/machineDetailTabs";
import { vsComponentName as DecommissionComponentName } from "./decommission";
import { vsComponentName as WarehouseComponentName } from "./warehouse";
import { vsComponentName as MoveComponentName } from "./move";

export function machineDetailConfigurationsComponentConfig(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addTabConfig({
    id: "configurations",
    displayName: "Configurations",
    uiSrefFragment: "configurations",
    requiredPermission: "machineView",
    stateDefinition: {
      component: ConfigurationsComponentName,
      url: "/configurations",
      resolve: {
        machine: ["machine", (machine: any) => machine],
      },
      bindings: {
        machine: "machine",
      },
    },
    children: [
      {
        uiSrefFragment: "decommission",
        stateDefinition: {
          component: DecommissionComponentName,
          url: "/decommission",
          resolve: {
            machine: ["machine", (machine: any) => machine],
          },
          bindings: {
            machine: "machine",
          },
        },
      },
      {
        uiSrefFragment: "warehouse",
        stateDefinition: {
          component: WarehouseComponentName,
          url: "/warehouse",
          resolve: {
            machine: ["machine", (machine: any) => machine],
          },
          bindings: {
            machine: "machine",
          },
        },
      },
      {
        uiSrefFragment: "move",
        stateDefinition: {
          component: MoveComponentName,
          url: "/move",
          resolve: {
            machine: ["machine", (machine: any) => machine],
          },
          bindings: {
            machine: "machine",
          },
        },
      },    
    ],
  });
}

machineDetailConfigurationsComponentConfig.$inject = [
  machineDetailTabsProviderName,
];
